// extracted by mini-css-extract-plugin
export var addButton = "_it-0";
export var border = "_it-8";
export var check = "_it-h";
export var danger = "_it-6";
export var dropdownContainer = "_it-1";
export var editModalBody = "_it-j";
export var footerContainer = "_it-i";
export var fullWidth = "_it-a";
export var hide = "_it-9";
export var icon = "_it-3";
export var input = "_it-7";
export var inputFlex = "_it-b";
export var inputWrapper = "_it-c";
export var manualFocus = "_it-5";
export var optionButton = "_it-4";
export var pillWrapper = "_it-e";
export var pointer = "_it-2";
export var showOverflow = "_it-f";
export var tagsFlex = "_it-d";
export var xButton = "_it-g";